<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
        width="80"
        align="center"
      />
      <el-table-column
        prop="value"
        label="比例值"
        width="180"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="choose(scope.row.value)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { chargeReturnDefault, chargeReturnDefaultcreate } from '@/api/providerAccountManagement/WeChatAccountFans.js'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async choose(value) {
      const data = await chargeReturnDefaultcreate({
        open_id: this.id,
        return_proportion: value
      })
      console.log('data', data)
      this.$message({
        message: '选择配比成功',
        type: 'success'
      })
      this.$emit('updata')
    },
    send(id) {
      console.log('收到')
      this.id = null
      this.id = id
      this.menlist()
    },
    async menlist() {
      const data = await chargeReturnDefault()
      this.tableData = data.data
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
